<template>
  <!--  15-2 教育机构应聘案件人员详情-->
  <div class="main-css">
    <!-- 主要信息部分 -->
    <div class="main-box">
      <!-- 左边 -->
      <div class="left-box" v-if="flag">
        <!-- 头部 信息显示 -->
        <div class="top-title">
          <el-tooltip
            :content="Table[0] && Table[0].medicalName"
            placement="top"
            :disabled="
              String(Table[0] && Table[0].medicalName).length > 8 ? false : true
            "
          >
            <div class="case-num" v-if="Table">
              {{ $t("medicalInstitution") }}
              {{ Table[0] && Table[0].medicalName }}
            </div>
          </el-tooltip>
          <el-tooltip
            :content="Table[0] && Table[0].jobId"
            placement="top"
            :disabled="
              String(Table[0] && Table[0].jobId).length > 8 ? false : true
            "
          >
            <div class="case-num" v-if="Table">
              {{ $t("caseNumber") }} {{ Table[0] && Table[0].jobId }}
            </div>
          </el-tooltip>
        </div>
        <!-- 主要信息部分 -->
        <div class="main-left-box">
          <!-- 案件名 -->
          <div class="case-name">
            <div class="title">{{ $t("projectTitle") }}</div>
            <p class="title-name" v-if="Table">
              {{ Table[0] && Table[0].jobName }}
            </p>
          </div>
          <!-- 显示图片 -->
          <div class="case-img">
            <img
              :src="imgList1"
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
              alt=""
            />
            <img
              :src="imgList2"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
            <img
              :src="imgList3"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
          </div>
          <!-- 标签部分 -->
          <div class="label-line-box">
            <div class="label-box" v-if="Table[0] && Table[0].label1 == '1'">
              {{
                language == "ja-JP"
                  ? Table[0] && Table[0].jplabel1_dictText
                  : Table[0] && Table[0].label1_dictText
              }}<span>×</span>
            </div>
            <div class="label-box" v-if="Table[0] && Table[0].label2 == 1">
              {{
                language == "ja-JP"
                  ? Table[0] && Table[0].jplabel2_dictText
                  : Table[0] && Table[0].label2_dictText
              }}<span>×</span>
            </div>
            <div class="label-box" v-if="Table[0] && Table[0].label3 == 1">
              {{
                language == "ja-JP"
                  ? Table[0] && Table[0].jplabel3_dictText
                  : Table[0] && Table[0].label3_dictText
              }}<span>×</span>
            </div>
            <div class="label-box" v-if="Table[0] && Table[0].label4 == 1">
              {{
                language == "ja-JP"
                  ? Table[0] && Table[0].jplabel4_dictText
                  : Table[0] && Table[0].label4_dictText
              }}<span>×</span>
            </div>
          </div>
          <!-- 第一行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">
                {{ $t("occupationCategory") }}
              </div>
              <div class="inline-left-title-main">
                {{
                  language == "ja-JP"
                    ? Table[0] && Table[0].jpworkType_dictText
                    : Table[0] && Table[0].workType_dictText
                }}
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("workLocation") }}</div>
              <el-tooltip
                :content="Table[0] && Table[0].workSpace"
                placement="top"
                :disabled="
                  String(Table[0] && Table[0].workSpace).length > 10
                    ? false
                    : true
                "
              >
                <div class="inline-left-title-main" v-if="Table">
                  {{ Table[0] && Table[0].workSpace }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("employmentForm") }}</div>
              <el-tooltip
                :content="
                  language === 'ja-JP'
                    ? `${Table[0] &&
                        Table[0].jpemploymentForm1_dictText} ${Table[0] &&
                        Table[0].jpemploymentForm2_dictText}  ${Table[0] &&
                        Table[0].jpemploymentForm3_dictText}  ${Table[0] &&
                        Table[0].jpemploymentForm4_dictText}`
                    : `${Table[0] &&
                        Table[0].employmentForm1_dictText} ${Table[0] &&
                        Table[0].employmentForm2_dictText}  ${Table[0] &&
                        Table[0].employmentForm3_dictText}  ${Table[0] &&
                        Table[0].employmentForm4_dictText}`
                "
                placement="top"
              >
                <div class="inline-left-title-main" v-if="Table">
                  <span v-if="Table[0] && Table[0].employmentForm1 === '1'">
                    <span v-if="language === 'ja-JP'">{{
                      Table[0] && Table[0].jpemploymentForm1_dictText
                    }}</span>
                    <span v-else>{{
                      Table[0] && Table[0].employmentForm1_dictText
                    }}</span>
                  </span>
                  <span v-if="Table[0] && Table[0].employmentForm2 === '1'">
                    <span v-if="language === 'ja-JP'">{{
                      Table[0] && Table[0].jpemploymentForm2_dictText
                    }}</span>
                    <span v-else>{{
                      Table[0] && Table[0].employmentForm2_dictText
                    }}</span>
                  </span>
                  <span v-if="Table[0] && Table[0].employmentForm3 === '1'">
                    <span v-if="language === 'ja-JP'">{{
                      Table[0] && Table[0].jpemploymentForm3_dictText
                    }}</span>
                    <span v-else>{{
                      Table[0] && Table[0].employmentForm3_dictText
                    }}</span>
                  </span>
                  <span v-if="Table[0] && Table[0].employmentForm4 === '1'">
                    <span v-if="language === 'ja-JP'">{{
                      Table[0] && Table[0].jpemploymentForm4_dictText
                    }}</span>
                    <span v-else>{{
                      Table[0] && Table[0].employmentForm4_dictText
                    }}</span>
                  </span>
                </div>
              </el-tooltip>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("dutyTime") }}</div>
              <div class="inline-left-title-main">
                {{ Table[0] && Table[0].workTime }}
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("salary") }}</div>
              <div class="inline-left-title-main">
             
              {{
               Table[0] && language === "ja-JP"
                  ?  Table[0].jphourSalary_dictText
                  : Table[0].hourSalary_dictText
              }}{{ Table[0].startSalary }}~{{ Table[0].endSalary }}
         
            
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">{{ $t("numberOfHires") }}</div>
              <div class="inline-left-title-main" v-if="Table">
                {{ Table[0] && Table[0].recruitNumber }}
              </div>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="inline-box">
            <div class="inline-left">
              <div class="inline-left-title">{{ $t("recruiter") }}</div>
              <div class="inline-left-title-main " v-if="Table">
                {{ Table[0] && Table[0].userName }}
              </div>
            </div>
            <div class="inline-right">
              <div class="inline-left-title">
                {{ $t("targetRecruitmentTime") }}
              </div>
              <div class="inline-left-title-main" v-if="Table">
                {{
                  Table[0] &&
                    Table[0].principalTime &&
                    Table[0].principalTime.split(" ")[0]
                }}
              </div>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("workContent") }}</div>
            <div class="long-box-main" v-if="Table">
              <el-tooltip
                :content="Table[0] && Table[0].workContent"
                placement="top"
                :disabled="
                  String(Table[0] && Table[0].workContent).length > 10
                    ? false
                    : true
                "
              >
                <div class="inline-left-title-main" v-if="Table">
                  {{ Table[0] && Table[0].workContent }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <!-- 第六行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("welfare") }}</div>
            <div class="long-box-main" v-if="Table">
              <el-tooltip
                :content="Table[0] && Table[0].welfareTreatment"
                placement="top"
                :disabled="
                  String(Table[0] && Table[0].welfareTreatment).length > 10
                    ? false
                    : true
                "
              >
                <div class="inline-left-title-main" v-if="Table">
                  {{ Table[0] && Table[0].welfareTreatment }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <!-- 第七行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("employmentConditions") }}</div>
            <div class="long-box-main" v-if="Table">
              <el-tooltip
                :content="Table[0] && Table[0].employmentConditions"
                placement="top"
                :disabled="
                  String(Table[0] && Table[0].employmentConditions).length > 10
                    ? false
                    : true
                "
              >
                <div class="inline-left-title-main" v-if="Table">
                  {{ Table[0] && Table[0].employmentConditions }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <!-- 第八行 -->
          <div class="inline-log-box">
            <div class="long-box-title">{{ $t("other") }}</div>
            <div class="long-box-main" v-if="Table">
              <el-tooltip
                :content="Table[0] && Table[0].other"
                placement="top"
                :disabled="
                  String(Table[0] && Table[0].other).length > 10 ? false : true
                "
              >
                <div class="inline-left-title-main" v-if="Table">
                  {{ Table[0] && Table[0].other }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边聊天部分 -->
      <div class="right-box" v-if="flag">
        <!-- 头部 信息显示 -->
        <div class="top-title">
          <el-tooltip
            :content="List[0] && List[0].resumeId"
            placement="top"
            :disabled="
              String(List[0] && List[0].resumeId).length > 6 ? false : true
            "
          >
            <div class="case-num" v-if="List">
              {{ $t("talentNumber") }} {{ List[0] && List[0].resumeId }}
            </div>
          </el-tooltip>
          <el-tooltip
            :content="List[0] && List[0].principal"
            placement="top"
            :disabled="
              String(List[0] && List[0].principal).length > 2 ? false : true
            "
          >
            <div class="case-num" v-if="List">
              {{ $t("employmentCharge") }} {{ List[0] && List[0].principal }}
            </div>
          </el-tooltip>
          <el-tooltip
            :content="Table[0] && Table[0].createTime.split(' ')[0]"
            placement="top"
            :disabled="
              String(Table[0] && Table[0].createTime.split(' ')[0]).length > 8
                ? false
                : true
            "
          >
            <div class="case-num" v-if="Table.length !== 0">
              {{ $t("applicationDate") }}
              {{ Table[0] && Table[0].createTime.split(" ")[0] }}
            </div>
          </el-tooltip>
        </div>
        <!--        信息栏-->
        <div class="info-box">
          <span class="info-box-title-css">{{ $t("allCandidates") }}</span>
          <div class="info-box-title">
            <el-dropdown
              class="el-dropdown-css"
              @command="handleCommandDropdown"
            >
   
              <span class="el-dropdown-link">
                <i
                  ><img
                    :src="listShowImg"
                    alt=""
                    @error="
                      e => {
                        e.target.src = require('@/assets/defaultImg.png');
                      }
                    "
                    style="width: 30px;height: 30px; border-radius: 50%;"
                /></i>
            
             <div class="dropdown-tooltips">  
                <i class="dropdown-i-css">{{ listShowName }}</i>
                <i class="dropdown-i-css">{{
                  listShowSex === "0" ? $t("male") : $t("female")
                }}</i>
                <i class="dropdown-i-css">{{  listShowBirth?listShowBirth.split(' ')[0]:'' }}</i>
                <i class="dropdown-i-css"> {{ listShowProfession }}</i>
                <i class="dropdown-i-css">{{ listShowJapanese }}</i>
             </div>
           
                <i class=" el-icon--right">
                  <img
                    src="./assets/Vector.png"
                    alt=""
                    class="info-img-css2"
                    @error="
                      e => {
                        e.target.src = require('@/assets/defaultImg.png');
                      }
                    "
                /></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in List"
                  :key="index"
                  :command="item"
                >
                  <i
                    ><img
                      :src="item.avatar"
                      alt=""
                      @error="
                        e => {
                          e.target.src = require('@/assets/defaultImg.png');
                        }
                      "
                      style="width: 30px;height: 30px; border-radius: 50%;"
                  /></i>

                  <i> {{ item.name }}</i>
                  <i> {{ item.sex }}</i>
                  <i>{{ item.birth }}</i>
                  <i>{{ item.school }}</i>
                  <i>{{ item.profession }}</i>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!--        进度框-->
        <div class="schedule-box">
          <span>{{ $t("promotionStatus") }}</span>
          <!-- 第一行 进度条部分 -->
          <div class="progress-bar">
            <div
              :class="lineShow1 ? 'line-between-active' : 'line-between-normal'"
            ></div>
            <div
              :class="
                itemShow1 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              1<span class="progress-title">{{ $t(processText[0]) }}</span>
            </div>
            <div
              :class="lineShow2 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow2 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              2<span class="progress-title">{{ $t(processText[1]) }}</span>
            </div>
            <div
              :class="lineShow3 ? 'line-center-active' : 'line-center-normal'"
            ></div>

            <div
              :class="
                itemShow3 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              3<span class="progress-title">{{ $t(processText[2]) }}</span>
            </div>

            <div
              :class="lineShow4 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow4 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              4<span class="progress-title">{{ $t(processText[3]) }}</span>
            </div>
            <div
              :class="lineShow5 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow5 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              5<span class="progress-title">{{ $t(processText[4]) }}</span>
            </div>
            <div
              :class="lineShow6 ? 'line-center-active' : 'line-center-normal'"
            ></div>
            <div
              :class="
                itemShow6 ? 'progress-item-active-big' : 'progress-item-normal'
              "
            >
              6<span class="progress-title">{{ $t(processText[5]) }}</span>
            </div>
            <div class="line-between-normal"></div>
          </div>
          <!--          第二行 -->
          <div class="input-box-css">
            <div class="input-box">
              {{ $t("situationId") }}：{{ $t(mesZhuIsShow) }}
            </div>
          </div>
          <!--          第四行-->
          <div class="box-title">
            <p>
              {{ $t("applicantSide") }} ：{{
                applicantSideTimeIsShow ? applicantSideTime : ""
              }}{{ $t(applicantSide) }}
              {{ $t(applicantSideWord) }}
              {{ applicantSideCompleteIsShow ? $t("complete") : "" }}
            </p>
          </div>
          <!--          第五行-->
          <div class="box-title">
            <p>
              {{ $t("recruitmentSide") }}：{{
                recruitmentSideTimeIsShow ? recruitmentSideTime : ""
              }}
              {{ $t(recruitmentSideWord) }}
              {{ timeIsShow ? $t("complete") : "" }}
            </p>
            <div class="button-box" v-if="buttonIsShow">
              <button
                class="button-css1"
                @click="updateEducationalApplyStatus(2)"
              >
                {{ $t("no") }}
              </button>
              <button
                class="button-css2"
                @click="updateEducationalApplyStatus(1)"
              >
                {{ $t("yes") }}
              </button>
            </div>
          </div>
        </div>
        <!--        聊天信息-->
        <div class="chat-box-css">
          <span>{{ $t("contactHistory") }}</span>
          <Socket></Socket>
        </div>
      </div>
    </div>
    <div class="main-button">
      <button @click="collect">{{ $t("collection") }}</button>
    </div>
  </div>
</template>

<script>
import Socket from "../../components/socket";
import {
  educationalGetApplyStatus,
  getUrlFromOSS,
  educationalUpdateApplyStatus,
  insertMedicalCollection,
  addEducationCollect
} from "../../js/api";
import axios from "axios";
import AES from "../../js/AES";
export default {
  name: "detailsOfApplicantsForCasesInEducationalInstitutions",
  components: { Socket },
  data() {
    return {
      imgList1: "",
      imgList2: "",
      imgList3: "",
      //461cae166a1d40c79c9d6b6e28d41ba9
      applyId: "",
      jobId: "",
      resumeId: "",
      label1: true,
      label2: true,
      label3: true,
      label4: true,
      labelListHandle: [],
      Table: [],
      List: [],
      listShowName: "",
      listShowSex: "",
      listShowBirth: "",
      listShowProfession: "",
      listShowJapanese: "",
      listShowImg: "",
      listImgIsShow: false,
      flag: true,
      lineShow1: false,
      lineShow2: false,
      lineShow3: false,
      lineShow4: false,
      lineShow5: false,
      lineShow6: false,
      lineShow7: false,
      itemShow1: false,
      itemShow2: false,
      itemShow3: false,
      itemShow4: false,
      itemShow5: false,
      itemShow6: false,
      buttonIsShow: false,
      processText: [
        "documentScreening",
        "interview",
        "contract",
        "statusOfResidence",
        "travel",
        "joiningCompany"
      ],
      mesZhuIsShow: "",
      applicantSide: "",
      recruitmentSideTime: "",
      recruitmentSideWord: "",
      applicantSideTime: "",
      applicantSideWord: "",
      timeIsShow: false,
      timeIsShowOne: false,
      applicantSideTimeIsShow: false,
      recruitmentSideTimeIsShow: false,
      applicantSideCompleteIsShow: false,
      statusName: "",
      language: ""
    };
  },
  created() {
    console.log("--------路由传参--------");
    console.log(1111, JSON.parse(this.$route.query.row));
    let obj = JSON.parse(this.$route.query.row) || null;
    this.language = this.$i18n.locale;
    this.applyId =
      (this.$route.params.row && this.$route.params.row.applyId) ||
      (obj && obj.applyId);
    this.jobId =
      (this.$route.params.row && this.$route.params.row.jobId) ||
      (obj && obj.jobId);
    this.resumeId =
      (this.$route.params.row && this.$route.params.row.resumeId) ||
      (obj && obj.resumeId);
    this.jobInfoListItem =
      (this.$route.params.row && this.$route.params.row.jobName) ||
      (obj && obj.jobName);
    this.select();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据2------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.applyId = that.$route.params.row.applyId;
        that.jobId = that.$route.params.row.jobId;
        that.resumeId = that.$route.params.row.resumeId;
        that.jobInfoListItem = that.$route.params.row.jobName;
        that.select();
      }
    },
    //图片回显
    getUrlList(url, number) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            if (number == 0) {
              this.imgList1 = aesFecInfo.message;
              console.log("第一張：" + this.imgList1);
            } else if (number == 1) {
              this.imgList2 = aesFecInfo.message;
              console.log("第二張：" + this.imgList2);
            } else if (number == 2) {
              this.imgList3 = aesFecInfo.message;
              console.log("第三張：" + this.imgList3);
            }
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },

    //顾名思义 应聘收藏
    collect(applyId) {
      var educationCollectAddDTO = {
        systemEventId: this.applyId,
        systemTypeId: 5
      };
      addEducationCollect(educationCollectAddDTO)
        .then(res => {
          console.log("教育机构添加应聘案件收藏", res);
          if (res.data.code === "A0000") {
            this.$message({
              message: "收藏成功！",
              type: "success"
            });
            this.$router.push({
              path: "/educationalInstitutionsCollectApplicationInformationList",
              name: "educationalInstitutionsCollectApplicationInformationList",
              params: {}
            });
          } else if (res.data.code === "A0506") {
            this.$message({
              message: this.$t("thisApplicationFavorite"),
              type: "warning"
            });
          } else {
            this.$message.error("提交错误！");
          }
        })
        .catch(res => {
          console.log("教育机构添加应聘收藏接口异常", res);
        });
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.label1 = false;
        this.labelListLength(1);
      } else if (num === 2) {
        this.label2 = false;
        this.labelListLength(2);
      } else if (num === 3) {
        this.label3 = false;
        this.labelListLength(3);
      } else if (num === 4) {
        this.label4 = false;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("正社員") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("アルバイト") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("特定技能") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("技能実習生") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("正社員");
      } else if (num === 2) {
        this.labelListHandle.push("アルバイト");
      } else if (num === 3) {
        this.labelListHandle.push("特定技能");
      } else if (num === 4) {
        this.labelListHandle.push("技能実習生");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "正社員") {
            this.labelListHandle.splice(i, 1);
            this.label1 = true;
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "アルバイト") {
            this.labelListHandle.splice(i, 1);
            this.label2 = true;
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "特定技能") {
            this.labelListHandle.splice(i, 1);
            this.label3 = true;
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "技能実習生") {
            this.labelListHandle.splice(i, 1);
            this.label4 = true;
          }
        }
      }
      console.log(this.labelListHandle);
    },
    //查询机构
    select() {
      let that = this;
      var applyJobStatusDTO = {
        applyId: this.applyId
        // applyId: "02314e633d03428a8b4d82258138519e"
      };
      axios({
        method: "post",
        url: "/api/modules-parent/eduApplicationManagement/getJobByApplication",
        data: applyJobStatusDTO,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("-----查询机构-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.Table = aesFecInfo.data;
            console.log("this.table77");
            console.log(that.Table);
            const data= this.Table[0]
            that.getUrlList(data && data.jobPhoto1, 0);
            that.getUrlList(data && data.jobPhoto2, 1);
            that.getUrlList(data && data.jobPhoto3, 2);
            console.log(aesFecInfo.data);
            that.option();
          }
        })
        .catch(res => {
          console.log(":", res);
        });
    },
    //获取下拉框数据
    option() {
      var ResumeListDTO = {
        jobId: this.jobId
      };
      axios({
        method: "post",
        url:
          "/api/modules-parent/eduApplicationManagement/getResumeByApplication",
        data: ResumeListDTO,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("-----获取下拉框数据-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.List = aesFecInfo.data;
            console.log(aesFecInfo.data);
            for (var i = 0; i < aesFecInfo.data.length; i++) {
              this.getListUrl(this.List, i);
              if (this.resumeId === aesFecInfo.data[i].resumeId) {
                this.listShowName = this.List[i].name;
                this.listShowSex = this.List[i].sex;
                this.listShowBirth = this.List[i].birth;
                this.listShowProfession = this.List[i].profession;
                this.listShowJapanese = this.List[i].japanese;
                (this.jobId = this.List[i].jobId),
                  (this.resumeId = this.List[i].resumeId),
                  (this.appId = this.List[i].appId),
                  this.getEducationalApplyStatus();
                this.listGetUrl(this.List[i].avatar);
              }
            }
          }
        })
        .catch(res => {
          console.log(":", res);
        });
    },
    // 下拉框选择
    handleCommandDropdown(command) {
      this.applyId = command.applyId;
      this.jobId = command.jobId;
      this.listShowName = command.name;
      this.listShowSex = command.sex;
      this.listShowBirth = command.birth;
      this.listShowProfession = command.profession;
      this.listShowJapanese = command.japanese;
      this.listShowImg = command.avatar;
      this.resumeId = command.resumeId;
      this.getEducationalApplyStatus();
    },
    // 状态查询
    getEducationalApplyStatus() {
      this.mesZhuIsShow = "";
      this.buttonIsShow = false;
      this.recruitmentSideWord = "";
      this.applicantSideWord = "";
      this.recruitmentSideTimeIsShow = false;
      this.applicantSideCompleteIsShow = false;
      this.applicantSideTimeIsShow = false;
      this.timeIsShow = false;
      var fakeInfo = {
        applyId: this.applyId
      };
      educationalGetApplyStatus(fakeInfo)
        .then(res => {
          console.log("----状态查询返回数据----");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo.data[0]);
          const aesFecInfoData = aesFecInfo.data[0];
          this.statusName = aesFecInfoData.statusName;
          if (res.data.code === "A1008") {
            this.lineShow1 = false;
            this.itemShow1 = false;
            this.lineShow2 = false;
            this.itemShow2 = false;
            this.lineShow3 = false;
            this.itemShow3 = false;
            this.lineShow4 = false;
            this.itemShow4 = false;
            this.lineShow5 = false;
            this.itemShow5 = false;
            this.lineShow6 = false;
            this.itemShow6 = false;
            this.mesZhuIsShow = "adminReviewing";
          } else if (res.data.code === "A1009") {
            this.lineShow1 = false;
            this.itemShow1 = false;
            this.lineShow2 = false;
            this.itemShow2 = false;
            this.lineShow3 = false;
            this.itemShow3 = false;
            this.lineShow4 = false;
            this.itemShow4 = false;
            this.lineShow5 = false;
            this.itemShow5 = false;
            this.lineShow6 = false;
            this.itemShow6 = false;
            this.mesZhuIsShow = "adminFailed";
          }else if (res.data.code === "A1009") {
             this.statusNameOpen(aesFecInfoData.statusName);
              this.mesZhuIsShow = "noSure";
              this.applicantSideWord = "WaitingEducational";
              this.recruitmentSideWord = "WaitingMedicalInstitution";
              this.buttonIsShow = true;
          }
           else if (res.data.code === "A1011") {
            if (
              aesFecInfoData.educationOperate === "0" &&
              aesFecInfoData.medicalOperate === "0"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.mesZhuIsShow = "waitingBothOperate";
              this.applicantSideWord = "WaitingEducational";
              this.recruitmentSideWord = "WaitingMedicalInstitution";
              this.buttonIsShow = true;
            } else if (
              aesFecInfoData.educationOperate === "0" &&
              aesFecInfoData.medicalOperate === "1"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = true;
              this.applicantSideWord = "WaitingEducational";
              this.mesZhuIsShow = "medicalInstitutionsHaveOperated";
              this.recruitmentSideTimeIsShow = true;
              this.timeOpen(aesFecInfoData);
              this.recruitmentSideWord = this.processText[
                aesFecInfoData.statusName
              ];
              this.timeIsShow = true;
            }
          } else if (res.data.code === "A1010") {
            this.statusNameOpen(aesFecInfoData.statusName);
            this.buttonIsShow = false;
            this.mesZhuIsShow = "educationalOperationCompleted";
            this.recruitmentSideWord = "WaitingMedicalInstitution";
            this.timeOpen(aesFecInfoData);
            this.applicantSideTimeIsShow = true;
            this.applicantSideWord = this.processText[
              aesFecInfoData.statusName
            ];
            this.applicantSideCompleteIsShow = true;
          } else if (res.data.code === "A1012") {
            if (
              aesFecInfoData.educationOperate === "1" &&
              aesFecInfoData.medicalOperate === "1"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = false;
              this.timeOpen(aesFecInfoData);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.applicantSideWord = "educationalOperationCompleted";
              this.recruitmentSideWord = "medicalOperationCompleted";
              this.mesZhuIsShow = "applicationCompleted";
            } else if (
              aesFecInfoData.educationOperate === "0" &&
              aesFecInfoData.medicalOperate === "2"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = false;
              this.timeOpen(aesFecInfoData);
              this.applicantSideWord = "educationalNotOperating";
              this.recruitmentSideTimeIsShow = true;
              this.recruitmentSideWord = "operationMedicalInstitutionFailed";
              this.mesZhuIsShow = "operationMedicalInstitutionFailed";
            } else if (
              aesFecInfoData.educationOperate === "1" &&
              aesFecInfoData.medicalOperate === "2"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = false;
              this.timeOpen(aesFecInfoData);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.applicantSideWord = "educationalOperationCompleted";
              this.recruitmentSideWord = "operationMedicalInstitutionFailed";
              this.mesZhuIsShow = "operationMedicalInstitutionFailed";
            } else if (
              aesFecInfoData.educationOperate === "2" &&
              aesFecInfoData.medicalOperate === "0"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = false;
              this.timeOpen(aesFecInfoData);
              this.applicantSideTimeIsShow = true;
              this.applicantSideWord = "educationalInstitutionsFailed";
              this.recruitmentSideWord = "medicalNotOperating";
              this.mesZhuIsShow = "educationalInstitutionsFailed";
            } else if (
              aesFecInfoData.educationOperate === "2" &&
              aesFecInfoData.medicalOperate === "1"
            ) {
              this.statusNameOpen(aesFecInfoData.statusName);
              this.buttonIsShow = false;
              this.timeOpen(aesFecInfoData);
              this.applicantSideTimeIsShow = true;
              this.recruitmentSideTimeIsShow = true;
              this.applicantSideWord = "educationalInstitutionsFailed";
              this.recruitmentSideWord = "medicalHavePassed";
              this.mesZhuIsShow = "educationalInstitutionsFailed";
            }
          }
        })
        .catch(res => {
          console.log("----状态查询返回数据----");
          console.log(res);
        });
    },
    //转态判断显示
    statusNameOpen(num) {
      if (num === 0) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = false;
        this.itemShow2 = false;
        this.lineShow3 = false;
        this.itemShow3 = false;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 1) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = false;
        this.itemShow3 = false;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 2) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = false;
        this.itemShow4 = false;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 3) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = false;
        this.itemShow5 = false;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 4) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = true;
        this.itemShow5 = true;
        this.lineShow6 = false;
        this.itemShow6 = false;
      } else if (num === 5) {
        this.lineShow1 = true;
        this.itemShow1 = true;
        this.lineShow2 = true;
        this.itemShow2 = true;
        this.lineShow3 = true;
        this.itemShow3 = true;
        this.lineShow4 = true;
        this.itemShow4 = true;
        this.lineShow5 = true;
        this.itemShow5 = true;
        this.lineShow6 = true;
        this.itemShow6 = true;
      }
    },
    // 时间判断显示(需要传输 data )
    timeOpen(data) {
      if (data.statusName === 0) {
        this.applicantSideTime = data.eduSelectionStatus;
        this.recruitmentSideTime = data.medicalSelectionStatus;
      } else if (data.statusName === 1) {
        this.applicantSideTime = data.eduInterviewStatus;
        this.recruitmentSideTime = data.medicalInterviewStatus;
      } else if (data.statusName === 2) {
        this.applicantSideTime = data.eduContractReadiness;
        this.recruitmentSideTime = data.medicalContractReadiness;
      } else if (data.statusName === 3) {
        this.applicantSideTime = data.eduResidenceStatus;
        this.recruitmentSideTime = data.medicalResidenceStatus;
      } else if (data.statusName === 4) {
        this.applicantSideTime = data.eduImmigrationStatus;
        this.recruitmentSideTime = data.medicalImmigrationStatus;
      } else if (data.statusName === 5) {
        this.applicantSideTime = data.eduMembershipStatus;
        this.recruitmentSideTime = data.medicalMembershipStatus;
      }
    },
    // 头像回显
    getUrl() {
      var fakeInfo = {
        message: this.item.avatar
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          console.log("-----------头像回显-----------");
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.listShowImg = aesFecInfo.message;
          }
          console.log(res);
        })
        .catch(res => {
          console.log("-----------头像回显-----------");
          console.log(res);
        });
    },
    // list图片回显
    getListUrl(item, i) {

      console.log(item);
      var fakeInfo = {
        message: item[i].avatar
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("-----------list图片回显-----------");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.List[i].avatar = aesFecInfo.message;
            if (i + 1 === item.length) {
              this.flag = true;
              console.log(this.List, "121212");
            }
          }
          console.log(res);
        })
        .catch(res => {
          console.log("-----------头像回显-----------");
          console.log(res);
        });
    },
    // list内部图片显示
    listGetUrl(item) {
      var fakeInfo = {
        message: item
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("-----------list渲染图片回显-----------");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.listShowImg = aesFecInfo.message;
          }
        })
        .catch(res => {});
    },
    // 教育机构应聘状态修改(两个按钮)
    updateEducationalApplyStatus(num) {
      var fakeInfo = {
        applyId: this.applyId,
        jobId: this.jobId,
        resumeId: this.resumeId,
        status: num,
        statusName: this.statusName
      };
      educationalUpdateApplyStatus(fakeInfo)
        .then(res => {
          console.log("--------教育机构应聘状态修改(两个按钮)--------");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("success"),
              type: "success"
            });
            this.getEducationalApplyStatus();
          } else {
            this.$message.error(this.$t("fail"));
          }
        })
        .catch(res => {
          console.log("--------教育机构应聘状态修改(两个按钮)--------");
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.top-title {
  height: 40px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.case-num {
  padding: 0 5px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin: 10px auto 0px;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-box {
  min-width: 1250px;
  margin: 0 auto;
  flex: 1;
  padding-left: 10px;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.left-box {
  width: 45%;
  float: left;
  overflow: hidden;
  padding-bottom: 20px;
}

.main-left-box {
  width: 568px;
  /* padding-right: 18px; */
  height: 750px;
  overflow-y: scroll;
}

.left-box /deep/ .case-img {
  width: 90%;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.case-img img {
  width: 150px;
  height: 114px;
}

.label-line-box {
  width: 95%;
  height: 30px;
  margin-top: 5px;
}

.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  margin-right: 20px;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.inline-left {
  width: 200px;
  height: 80px;
  margin-right: 45px;
  float: left;
}

.inline-right {
  width: 240px;
  height: 80px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.inline-left-title-main {
  height: 50px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-box {
  height: 80px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 150px;
}

.long-box-title {
  height: 30px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.right-box {
  width: 45%;
  float: left;
  margin-left: 20px;
}

.right-box /deep/ .chat-box {
  height: 450px;
  border: 0;
  box-shadow: unset;
}

.right-box /deep/ .title-main {
  height: 320px;
}

.info-box {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.info-box .info-box-title-css {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.el-dropdown-css {
  width: 500px;
}

.info-img-css1 {
  border-radius: 50%;
}

.info-img-css2 {
  margin-left: 0px;
}

.schedule-box {
  width: 100%;
  height: 200px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.box-title {
  margin-top: 12px;
  padding-left: 65px;
  letter-spacing: 0.25px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #686868;
}

.info-box-title {
  margin-top: 15px;
  padding-left: 100px;
  letter-spacing: 0.25px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #686868;
}

.dropdown-i-css {
  margin: 0 5px;
}
.dropdown-tooltips{
  display: inline-block;
  width: 340px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}
.el-dropdown-link{
  display: flex;
  align-items: center;
}
.schedule-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css {
  width: 100%;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  padding: 0 70px;
  position: relative;
}

.chat-box-css span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css /deep/ .search .el-input__inner {
  background: transparent;
}

.chat-box-css /deep/ .send-message {
  height: 60px;
}

.chat-box-css /deep/ .send-message .el-input__inner {
  border-radius: 0;
  border-bottom: 1px solid #51abff;
}

.progress-bar {
  height: 20px;
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.line-between-active {
  height: 2px;
  width: 40px;
  background: #51abff;
}

.line-between-normal {
  height: 2px;
  width: 40px;
  background: #dce3e9;
}

.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.progress-title {
  width: 65.33px;
  height: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #252a31;
  flex: none;
  order: 0;
  flex-grow: 1;
  margin-top: 36px;
  margin-left: -45px;
}

.progress-item-active-big {
  width: 23px;
  height: 23px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}

.line-center-active {
  width: 60px;
  height: 2px;
  background: #51abff;
}

.line-center-normal {
  width: 60px;
  height: 2px;
  background: #dce3e9;
}

.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}

.input-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  gap: 10px;
  position: absolute;
  width: 75%;
  height: 32px;
  left: 105px;
  top: 80px;
  background: #fc630c;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.input-box-css {
  width: 100%;
  height: 35px;
  margin-top: 40px;
}

.button-box {
  height: 24px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-left: 40px;
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.button-css1 {
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
  width: 50px;
  height: 24px;
  font-family: "Poppins";
  font-style: normal;
  line-height: 18px;
  align-items: center;
  text-align: center;
}

.button-css2 {
  background: #51abff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fafafa;
  margin-right: 25px;
  cursor: pointer;
  width: 70px;
  height: 24px;
  font-family: "Poppins";
  font-style: normal;
  line-height: 18px;
  align-items: center;
  text-align: center;
}

.main-button {
  width: 500px;
  height: 50px;
  text-align: center;
  /*margin-left: 455px;*/
  margin-left: 30%;
  margin-bottom: 80px;
}

.main-button button {
  cursor: pointer;
  height: 40px;
  width: 152px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/detailsOfApplicantsForCasesInEducationalInstitutions/index.vue